export enum BlogSortingEnum {
  New = 1,
  Old = 2,
  Featured = 3,
  TitleAsc = 4,
  TitleDesc = 5,
}
